export const OSLO_MUNICIPALITY = '0301'
